import idb from "../../helpers/indexedDB";

export const addScreenPath = (screen) =>{
    const currentPath = idb.getJSONSync("screenPath") || [];
    if(currentPath.length>1 && currentPath[currentPath.length-1]===screen){
        return;
    }
    currentPath.push(screen);
    idb.setJSONSync("screenPath", currentPath);
    
}
export const resetScreenPath =()=>{
    idb.removeItemSync("screenPath");
}
export const getLatestScreenPath = () =>{
    const currentPath = idb.getJSONSync("screenPath") || [];
    if(currentPath.length>0){
        const latestPath = currentPath.slice(-4);
        return latestPath.join(",")
    }
    return "";
}